import { Link } from "react-router-dom";
import { MapPin, ArrowRight, Clock, ArrowRightLeft } from "lucide-react";
import { POPULAR_PAIRS } from "@/pages/routes/routesData";

export default function PopularRoutes() {
  return (
    <section
      id="popular-routes"
      data-testid="popular-routes-section"
      className="relative py-24 md:py-28 border-t border-[#e5e7eb] bg-[#F9FAFB]"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-2xl">
          <span className="font-display text-[11px] uppercase tracking-[0.25em] text-[#5FA836] font-bold">
            Popular routes
          </span>
          <h2 className="mt-3 font-display text-3xl md:text-5xl font-black tracking-[-0.03em] leading-tight text-[#24303F]">
            Where India rides <span className="text-gray-400">together.</span>
          </h2>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {POPULAR_PAIRS.map((p) => (
            <Link
              key={p.primarySlug}
              to={`/${p.primarySlug}`}
              data-testid={`popular-route-${p.primarySlug}`}
              className="group rounded-3xl border border-[#e5e7eb] bg-white p-6 hover:border-[#5FA836]/60 hover:shadow-[0_20px_40px_-24px_rgba(95,168,54,0.25)] transition-all"
            >
              <div className="flex items-center gap-2">
                <div className="h-9 w-9 rounded-xl bg-[#5FA836]/10 grid place-items-center text-[#5FA836]">
                  <MapPin className="w-4 h-4" />
                </div>
                <div className="font-display text-[10px] uppercase tracking-[0.2em] text-gray-500 font-bold">
                  Bidirectional route
                </div>
              </div>

              <div className="mt-5 font-display text-xl md:text-[22px] font-black leading-tight text-[#24303F] flex items-center gap-2 flex-wrap">
                <span>{p.cityA}</span>
                <ArrowRightLeft className="w-4 h-4 text-[#5FA836] shrink-0" />
                <span>{p.cityB}</span>
              </div>

              <div className="mt-5 flex items-center gap-6 text-sm font-body text-gray-600">
                <span className="flex items-center gap-1.5">
                  <Clock className="w-3.5 h-3.5" /> {p.durationHours} hrs
                </span>
                <span className="flex items-center gap-1.5">
                  <MapPin className="w-3.5 h-3.5" /> {p.distanceKm} km
                </span>
              </div>

              <div className="mt-5 pt-4 border-t border-[#e5e7eb] flex items-center gap-1.5 text-[#5FA836] font-display text-sm font-bold group-hover:gap-2.5 transition-all">
                Explore route
                <ArrowRight className="w-4 h-4" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
